//formats price to int if no decimals and to 2 decimals if decimal

export const formatFloatPrice = (price: number | null) =>
  Number(String(price || 0).replace(',', '.')) || 0
